import { utils } from '@bayclubs/ui-core';
import { BlockedSlotSaveInputModel } from '../models/blocked-slot-save-input.model';

export enum BlockedSlotSaveActionTypes {
    LoadForm = '[BlockedSlotSave] Load form',
    SaveBlockedSlot = '[BlockedSlotSave] Save blocked slot',
    SaveBlockedSlotSuccess = '[BlockedSlotSave] Save blocked slot success',
    ClubChanged = '[BlockedSlotSave] Club changed',
    ClearSaveForm = '[BlockedSlotSave] Clear save form',
    LoadCourts = '[BlockedSlotSave] Load courts',
}

export class LoadFormAction {
    static type = BlockedSlotSaveActionTypes.LoadForm;

    constructor(public input: BlockedSlotSaveInputModel) { }
}

export class SaveBlockedSlotAction {
    static type = BlockedSlotSaveActionTypes.SaveBlockedSlot;
}

export class SaveBlockedSlotSuccessAction {
    static type = BlockedSlotSaveActionTypes.SaveBlockedSlotSuccess;
}

export class ClearSaveFormAction {
    static type = BlockedSlotSaveActionTypes.ClearSaveForm;
}

export class LoadCourtsAction {
    static type = BlockedSlotSaveActionTypes.LoadCourts;

    constructor(public clubId: string = null, public date: utils.BcDate = null) { }
}